import React from "react"

import {
  GlobalSearchModel,
  GlobalSearchOption
} from "features/global-search/types/GlobalSearch"

import { GlobalSearchOverlayView } from "./ui/GlobalSearchOverlayView"

export interface GlobalSearchOverlayModel extends GlobalSearchModel {
  onChange: (option: GlobalSearchOption | null) => void
  onClose: () => void
}

export type GlobalSearchOverlayProps = GlobalSearchOverlayModel

export const GlobalSearchOverlay = React.memo(
  (props: GlobalSearchOverlayProps) => <GlobalSearchOverlayView {...props} />
)
